import { PRESUPUESTADOR_CLEAR_REPORT_STATE } from './constants';

export function clearReportPresupuestador() {
  return async (dispatch) => {

    dispatch({
      type: PRESUPUESTADOR_CLEAR_REPORT_STATE
    });

  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_CLEAR_REPORT_STATE) {
    return {
      ...state,
      reportFilePresupuestoPending: false,
      reportFilePresupeustadorError: null,
      reportFilePresupeustadorSuccess: false
    }
  }
  else {
      return state
  }
}
